/**
 * Whether Sean's composer holds a message the user has not sent. Sean's
 * panel outlives page navigation, so its draft is the one thing a reload on
 * navigation would lose; recovering from a deploy asks before reloading
 * while one is held. Kept in memory only: a reload is exactly what it guards.
 */

const holds = new Set<symbol>();
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) {
    listener();
  }
}

/** Marks an unsent message until the returned release is called. */
export function holdUnsentFolioMessage(): () => void {
  const hold = Symbol('unsent Sean message');
  holds.add(hold);
  notify();
  return () => {
    holds.delete(hold);
    notify();
  };
}

export function hasUnsentFolioMessage(): boolean {
  return holds.size > 0;
}

/** Calls `listener` whenever a message is held or released; returns the unsubscribe. */
export function subscribeToUnsentFolioMessage(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
